
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/one/business",
      function () {
        return require("private-next-pages/pricing/one/business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/one/business"])
      });
    }
  